module.exports = __webpack_public_path__ + "static/media/CTLI_17-391w.532d9447.png";